module.exports = __webpack_public_path__ + "static/media/colour.b37ddca4.svg";